import { cn } from "./utils";

export interface BalloonProps {
  role: "user" | "assistant";
  className?: string;
  children: React.ReactNode;
}

export const Balloon = ({ role, className, children }: BalloonProps) => {
  return (
    <div
      className={cn("mt-3 flex w-auto max-w-[85%] flex-col gap-1", {
        "self-start items-start": role === "assistant",
        "self-end items-end": role === "user",
      })}
    >
      <div
        className={cn(
          "relative block space-y-2 rounded-lg py-4",
          {
            "bg-gray-100": role === "assistant",
            "bg-slate-900": role === "user",
          },
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
};
